// extracted by mini-css-extract-plugin
module.exports = {"header":"New_header_3ZcST","body":"New_body_1Sn7K"};